import React from 'react';
import { getMinimumCount, getStandingsConfig, useHorizontalScrollSpy, getPlayoffCounter } from "./utils";

function Table({
  baseClass,
  getTableProps,
  getTableBodyProps,
  headerGroups,
  rows,
  prepareRow,
  tableConfig,
  extraClasses,
  tableIsGrouped,
  tableReferences,
  headerPure,
  isGroupedByDivision
}) {
  const [ref, isOriginalPosition] = useHorizontalScrollSpy(headerGroups);
  const emptyRows = !rows || rows.length < 1;
  const { homeAdvantage, topClubsLegend, playoffQualifiedEastConference, playoffQualifiedWestConference, playoffQualifiedCentralConference, homeAdvantageLegend, topClubs } = tableConfig || {};
  const header = headerGroups?.[0]?.headers?.[0]?.Header;

  let topClubsCounter = topClubsLegend ? getMinimumCount(topClubs, homeAdvantage, 1) : null;
  const playoffQualified = Math.max(Number.isInteger(playoffQualifiedEastConference) ? playoffQualifiedEastConference : 0, Number.isInteger(playoffQualifiedWestConference) ? playoffQualifiedWestConference : 0, Number.isInteger(playoffQualifiedCentralConference) ? playoffQualifiedCentralConference : 0);
  let homeAdvantageCounter = homeAdvantageLegend && header && !header.includes('none') ? getMinimumCount(homeAdvantage, playoffQualified, 4) : null;
  let playoffQualifiedCounter = !isGroupedByDivision ? getPlayoffCounter(headerPure, playoffQualifiedEastConference, playoffQualifiedWestConference, playoffQualifiedCentralConference) : null;

  return (
    <>
      <div ref={ref} className={`${baseClass}__table`}>
        <table className={`mls-o-table ${extraClasses ? extraClasses : ""} ${emptyRows ? `mls-o-table--empty` : ""} ${topClubs ? `mls-o-table--top-clubs-${topClubs}` : ""} ${playoffQualified ? `mls-o-table--playoff-qualified-${playoffQualified}` : ""} ${homeAdvantage ? `mls-o-table--home-advantage-${homeAdvantage}` : ""}`}  {...getTableProps()}>
          <thead className="mls-o-table__header">
            {headerGroups.map((headerGroup, headerGroupIndex) => (
              <tr key={`tr_${headerGroupIndex}`}
                className={`mls-o-table__header-group ${headerGroupIndex === 0 ? 'mls-o-table__header-group--main' : ''}`} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, tableHeaderIndex) => (
                  <th key={`th_${tableHeaderIndex}`}
                    className={`mls-o-table__header ${tableHeaderIndex === 0 && !isOriginalPosition ? "shadow" : ""} ${column.isSorted ? "mls-o-table__header--sorted" : ""} ${column.originalId ? column.originalId : column.id}`} tabIndex="0" role="button"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        column.toggleSortBy(!column.isSortedDesc);
                      }
                    }}
                    {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}>
                    <div
                      className={`mls-o-table__header-title ${column.isSorted && !column.isSortedDesc ? "mls-o-table__header-title--asc" : ""} ${column.isSorted && column.isSortedDesc ? "mls-o-table__header-title--desc" : ""}`}>
                      <span className={`mls-o-table__header-text-wrapper`}>
                        <span
                          className={`mls-o-table__header-text ${column.isSorted || !column.canSort ? "" : 'mls-o-table__header-text--unsorted'}`}>{column.render("Header")}</span>
                      </span>
                      {
                        column.canSort
                          ? <div role="button" className={`mls-o-table__header-icon`} />
                          : null
                      }
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody className="mls-o-table__body" {...getTableBodyProps()}>
            {!emptyRows
              ? rows.map((row, rowIndex) => {
                prepareRow(row);

                if (rowIndex !== 0 && topClubsCounter > 0) {
                  topClubsCounter--;
                }

                if (rowIndex !== 0 && playoffQualifiedCounter > 0) {
                  playoffQualifiedCounter--;
                }

                if (rowIndex !== 0 && homeAdvantageCounter > 0) {
                  homeAdvantageCounter--;
                }

                return (
                  <tr key={`row_${rowIndex}`} className={`mls-o-table__row mls-o-table__row--${rowIndex + 1} ${tableConfig ? getStandingsConfig(topClubsCounter, homeAdvantageCounter, playoffQualifiedCounter, tableIsGrouped) : ""}`} {...row.getRowProps()}>
                    {row.cells.map((cell, index) => {
                      return (
                        <td key={`col_${index}`}
                          className={`mls-o-table__cell ${index === 0 && !isOriginalPosition ? "shadow" : ""} ${cell.column.isSorted ? 'mls-o-table__cell--sorted' : ''} ${cell.column.id}`}
                          {...cell.getCellProps()}>
                          {cell.render("Cell")}
                        </td>
                      );
                    })}
                  </tr>
                );
              }) : null
            }
          </tbody>
        </table>
        <div className="mls-o-table__overlay" />
      </div>
    </>
  );
}

// eslint-disable-next-line no-func-assign
Table = React.memo(Table);

export default Table;
